import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { Link } from "react-router-dom";

import { setBreadcrumb } from "../../actions/common";
import Grid from "@material-ui/core/Grid";
import colors from "../../assets/style/colors";
import FRDefinition from "./FRDefinition";
import StructuralView from "./StructuralView";
import FRConfiguration from "./FRConfiguration";
import RuleSets from "./RuleSets";

const styles = {
  mainContainer: {
    width: "100%",
    margin: "0 auto",
    paddingBottom: "0px",
  },
  tabContainer: {
    paddingLeft: "30px",
  },
  link: {
    textDecoration: "none",
  },
  tab: {
    minWidth: "120px",
    textAlign: "center",
    backgroundColor: colors.white,
    fontSize: "0.875em",
    borderRadius: "2px",
    //borderWidth: "1px",
    //borderStyle: "solid",
    borderBottom: "none",
    marginRight: "10px",
    padding: "6px 12px",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    border: "1px solid " + colors.primary,
  },
  inactive: {
    color: colors.black54,
    height: "32px",
    cursor: "pointer",
  },
  active: {
    color: colors.black87,
    height: "34px",
    cursor: "default",
    paddingTop: "4px",
    borderTopWidth: "3px",
  },
  refresh: {
    "& img": {
      marginLeft: "10px",
      width: "20px",
      cursor: "pointer",
    },
  },
};

class Config extends Component {
  mounted = false;

  constructor(props) {
    super(props);
    props.dispatch(setBreadcrumb([{ name: I18n.get("topbar_configuration") }]));
    this.state = {
      tabValue: props.match.params.tab,
      displayDetails: {},
    };
  }

  componentDidMount() {
    this.mounted = true;
    console.log("componentDidMount");
    if (!this.props.match.params.tab) this.setState({ tabValue: "0" });
  }

  componentWillUnmount() {
    this.mounted = false;
    console.log("componentWillUnmount");
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
    console.log(this.props.match.params.tab);
    if (this.props.match.params.tab) {
      let tabVal = this.props.match.params.tab;
      if (this.mounted && tabVal !== this.state.tabValue) {
        this.setState({ tabValue: tabVal });
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid container direction="column" alignItems="stretch">
        <Grid item xs className={classes.mainContainer + " mainContainer"}>
          <Grid container className={classes.tabContainer}>
            {[
              { id: "0", name: I18n.get("site_structuralView") },
              { id: "1", name: I18n.get("site_frDefinition") },
              { id: "2", name: I18n.get("site_frConfiguration") },
              { id: "3", name: I18n.get("site_RuleSets") },
            ].map((tab, index) => (
              <React.Fragment key={tab.id}>
                {
                  <Link
                    to={"/admin/config/" + tab.id}
                    className={classes.link}
                    key={tab.id}
                  >
                    <Grid
                      item
                      className={
                        classes.tab +
                        (this.state.tabValue === tab.id
                          ? " " + classes.active
                          : " " + classes.inactive)
                      }
                    >
                      <span
                        style={{
                          paddingLeft:
                            index > 1 && Number.isInteger(tab.id)
                              ? "16px"
                              : "0px",
                        }}
                      >
                        {tab.name}
                      </span>
                    </Grid>
                  </Link>
                }
              </React.Fragment>
            ))}
          </Grid>
          {this.state.tabValue === "0" && <StructuralView />}
          {this.state.tabValue === "1" && <FRDefinition />}
          {this.state.tabValue === "2" && <FRConfiguration />}
          {this.state.tabValue === "3" && <RuleSets />}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Config));
